import React from 'react';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import { parse, stringify } from 'query-string';
import _ from 'underscore';
import { animateScroll } from 'react-scroll';
import Cookies from 'js-cookie';

import isValidEmail from '../../utils/isValidEmail';
import { safeCredentials, handleErrors } from '../../utils/fetchHelpers';
import { Loading } from '../../components/Loading';
import conversionTracker from '../../utils/conversionTracker';
import alertSysAdmin from '../../utils/alertSysAdmin';

import ShoppingCart from './ShoppingCart';
import StepZero from './StepZero';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';

class Enrollment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      description: '',
      email: '',
      start_date: '',
      selectedTrack: null,
      selectedProgram: null,
      discount_code: null,
      paymentError: false,
      loaded: false,
      rate: 1.0,
      currentStep: null,
      tracks: [],
    };
  }

  componentDidMount() {
    this.loadOptions();

    fetch('/api/v2/tracks', safeCredentials({}))
      .then(handleErrors)
      .then(tracks => {
        this.setState({ tracks: tracks.data });
      });
  }

  componentWillReceiveProps(nextProps) {
    const thisQuery = parse(this.props.location.search);
    const nextQuery = parse(nextProps.location.search);
    if (thisQuery.track !== nextQuery.track) {
      this.setState({ loaded: false, currentStep: null }, () => {
        this.loadOptions(nextProps);
        this.scrollToTop();
      });
    }
  }

  loadOptions = (props = this.props) => {
    const query = parse(props.location.search);
    const discountCookie = Cookies.get("discount_code");

    const discount_code = discountCookie || query.discount_code;

    if (discount_code) {
      fetch(`/api/v2/discounts/${discount_code}`, safeCredentials({}))
      .then(res => res.json())
      .then((res) => {
        this.setState({
          rate: res.attributes.metadata.rate,
          discount_code: discount_code,
        });
      })
      .catch(() => {});
    }

    if (!query.track) {
      this.setState({
        loaded: true,
        selectedTrack: null,
      }, () => { this.changeStep(0); });
      return;
    }

    if (query.track) {
      fetch(`/api/v2/tracks/${query.track}`, safeCredentials({}))
      .then(handleErrors)
      .then((res) => {
        this.setState({
          selectedTrack: res.data,
          selectedProgram: query.program,
          description: query.track,
          // loaded: true,
        }, () => {
          if (this.state.selectedProgram) {
            this.changeStep(2);
          } else {
            this.changeStep(1);
          }

          if (query.custom_id) {
            fetch(`/api/v2/orders/${query.custom_id}`, safeCredentials({}))
            .then(handleErrors)
            .then((res) => {
              this.setState({
                first_name: res.order.first_name,
                last_name: res.order.last_name,
                email: res.order.email,
                start_date: res.order.start_date,
              }, () => {
                this.changeStep(3);

                this.setState({ loaded: true });
              })
            })
          } else {
            this.setState({ loaded: true });
          }
        });
      });
    }
  }

  refreshUrl = (props = this.props) => {
    const query = parse(props.location.search);

    if (!this.state.selectedTrack) {
      if (query.discount_code) {
        props.history.replace({
          pathname: '/enroll',
          search: stringify({ discount_code: query.discount_code }),
        });
      } else {
        props.history.replace({
          pathname: '/enroll'
        });
      }

      return;
    }

    if (this.state.discount_code) {
      props.history.replace({
        pathname: '/enroll',
        search: stringify({ track: query.track, discount_code: this.state.discount_code, program: this.state.selectedProgram }),
      });
    } else {
      props.history.replace({
        pathname: '/enroll',
        search: stringify({ track: query.track, program: this.state.selectedProgram }),
      });
    }
  }

  selectProgram = (name) => {
    this.setState({ selectedProgram: name }, () => {
      this.changeStep(2);
    });
  }

  changeStep = (step, reset = false) => {
    if (reset) {
      this.setState({ currentStep: null, selectedTrack: null, selectedProgram: null }, this.refreshUrl);
      return;
    }
    if (step === 0) {
      conversionTracker(window, 'InitiateCheckout', {
        step,
      });
    }
    if (step === 1) {
      this.setState({ selectedProgram: null }, this.refreshUrl);
      conversionTracker(window, 'PickProduct', {
        step,
        nanomajor_long_symbol: this.state.selectedTrack.attributes.long_symbol,
        content_category: 'nanomajors',
      });
    }
    if (step === 2) {
      this.refreshUrl();
      conversionTracker(window, 'AddToCart', {
        step,
        value: this.calculateTotalPrice(),
        variant: this.state.selectedProgram,
        nanomajor_long_symbol: this.state.selectedTrack.attributes.long_symbol,
        content_category: 'nanomajors',
      });
    }
    if (this.state.currentStep === 2 && step === 3) {
      conversionTracker(window, 'AddPaymentInfo', {
        step,
        value: this.calculateTotalPrice(),
        nanomajor_long_symbol: this.state.selectedTrack.attributes.long_symbol,
        variant: this.state.selectedProgram,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        start_date: this.state.start_date,
        content_category: 'nanomajors',
        discount_code: this.state.discount_code,
        terms_of_service_agreement_checked: true,
        privacy_policy_agreement_checked: true,
      });
    }
    this.setState({ currentStep: step }, this.scrollToTop);
  }

  calculateTotalPrice = (installment=false) => {
    if (this.state.selectedTrack) {
      if (installment) {
        return Math.round(_.find(this.state.selectedTrack.relationships.price_options.data, option => option.attributes.name === this.state.selectedProgram).attributes.amount_installment * this.state.rate * 100) / 100;
      } else {
        return Math.round(_.find(this.state.selectedTrack.relationships.price_options.data, option => option.attributes.name === this.state.selectedProgram).attributes.amount * this.state.rate * 100) / 100;
      }
    }
  }

  modifyForm = (data) => {
    this.setState(data);
  };

  canProceed = (step) => {
    switch (step) {
    case 3:
      if (this.state.first_name === '' || this.state.last_name === '' || !isValidEmail(this.state.email) || this.state.start_date === '') {
        return { status: false, message: 'Next' };
      }

      return { status: true, message: 'Next' };
    default:
      break;
    }
  };

  scrollToTop = () => {
    animateScroll.scrollToTop();
  }

  render() {
    if (!this.state.loaded || this.state.tracks.length === 0) {
      return <Loading />;
    }

    return (
      <div>
        <Helmet
          title={'Enroll Now'}
          meta={[
            { name: 'description', content: 'Enroll in our online programs now' },
            { name: 'keywords', content: 'Enroll, Register, Student Registration, 100% online program' },
          ]}
        />

        <ShoppingCart
          currentStep={this.state.currentStep}
          changeStep={this.changeStep}
          canProceed={this.canProceed}
          email={this.state.email}
        />

        {(() => {
          switch (this.state.currentStep) {
          case 0:
            return (<StepZero
                {...this.props}
                tracks={this.state.tracks}
                rate={this.state.rate}
              />);
          case 1:
            return (<StepOne
                {...this.props}
                tracks={this.state.tracks}
                selectedTrack={this.state.selectedTrack}
                rate={this.state.rate}
                selectProgram={this.selectProgram}
                changeStep={this.changeStep}
              />);
          case 2:
            return (<StepTwo
                changeStep={this.changeStep}
                modifyForm={this.modifyForm}
                first_name={this.state.first_name}
                last_name={this.state.last_name}
                email={this.state.email}
                start_date={this.state.start_date}
                canProceed={this.canProceed}
                selectedTrack={this.state.selectedTrack}
                selectedProgram={this.state.selectedProgram}
                rate={this.state.rate}
              />);
          case 3:
            return (<StepThree
                changeStep={this.changeStep}
                currentStep={this.state.currentStep}
                calculateTotalPrice={this.calculateTotalPrice}
                selectedTrack={this.state.selectedTrack}
                selectedProgram={this.state.selectedProgram}
                first_name={this.state.first_name}
                last_name={this.state.last_name}
                email={this.state.email}
                start_date={this.state.start_date}
                canProceed={this.canProceed}
                paying={this.state.paying}
                paymentError={this.state.paymentError}
                rate={this.state.rate}
                discount_code={this.state.discount_code}
              />);
          default:
            return null;
          }
        })()}
      </div>
    );
  }
}

const EnrollmentWithRouter = () => {
  const EnrollmentWrapped = withRouter(Enrollment);
  return <Router><EnrollmentWrapped /></Router>;
}

export default EnrollmentWithRouter;
